import { createNamespacedHelpers } from "vuex";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";

export default {
    ...createNamespacedHelpers("ABTest"),
    createConfig: () => ({
        namespaced: true,
        actions,
        getters,
        mutations,
        state
    })
};



// WEBPACK FOOTER //
// ./src/store/ABTest/index.js